'use client';

import { useQueryState } from 'nuqs';
import { useRef } from 'react';

import { ScrollToContactCardProvider } from '~/landing/core/simulator/scroll-to-contact-card-context';

import { Client } from './client';
import { Header } from './components/header';
import { Client as DemoClient } from './demo/client';

export const SimulatorClientWrapper = () => {
  const [view, setView] = useQueryState('view', {
    defaultValue: 'landing',
    shallow: false,
  });
  const contactCardRef = useRef<HTMLDivElement>(null);

  const scrollToContactCard = () => {
    if (contactCardRef.current) {
      contactCardRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToDemo = () => setView('demo');
  const goToLanding = () => setView('landing');

  const currentView = view === 'demo' ? 'demo' : 'landing';

  return (
    <ScrollToContactCardProvider scrollToContactCard={scrollToContactCard}>
      <Header
        goToDemo={goToDemo}
        goToLanding={goToLanding}
        view={currentView}
      />
      {currentView === 'landing' ? (
        <Client contactCardRef={contactCardRef} goToDemo={goToDemo} />
      ) : (
        <DemoClient contactCardRef={contactCardRef} />
      )}
    </ScrollToContactCardProvider>
  );
};
